import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LangService } from 'src/app/core/services/lang.service';
import { globalVariables } from 'src/app/core/constants/globalVariables';

@Component({
  selector: 'app-bank-detail',
  templateUrl: './../../../templates/forms/modals/bank-detail.component.html',
})
export class BankDetailComponent implements OnInit {
  psDateFormat:any;
  @Input()
  config: any;
  
  @Input()
  modalShow: boolean = true;
  
  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj:any;
  public searchString;

  bankOptions: any = {
    // "chequeNo": {
    //   "required": {
    //     "message": "Cheque No required",
    //   }
    // },
    // "bankName": {
    //   "required": {
    //     "message": "Bank Name required",
    //   }
    // },
    // "bankAccno": {
    //   "required": {
    //     "message": "Bank Acc No required",
    //   }
    // },
  }

  constructor(public langService: LangService) { }

  ngOnInit() {
    this.psDateFormat = globalVariables.psDateFormat;
    this.dataObj.CHEQUE_DATE = this.dataObj.CHEQUE_DATE ? this.dataObj.CHEQUE_DATE : new Date();

  }

  onClickOk(form) {
    const validationResult = form.validate();
    if (validationResult.isValid) {
      this.modalShow=false;this.submit.next();

    }

  }

}
